// extracted by mini-css-extract-plugin
module.exports = {"content":"dataset-accordion_content__paOrv","open":"dataset-accordion_open__yyElh","close":"dataset-accordion_close__F4TPs","trigger":"dataset-accordion_trigger__QvsVP"};